import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

const STATUS_STYLES: Record<string, string> = {
	RESOLVED: 'bg-kaefer-grass-green/15 text-kaefer-forest-green',
	COMPLETED: 'bg-kaefer-grass-green/15 text-kaefer-forest-green',
	IN_PROGRESS: 'bg-kaefer-light-silver/60 text-kaefer-dark-grey',
	PENDING: 'bg-kaefer-light-silver/60 text-kaefer-dark-grey',
	ORIENTED: 'bg-kaefer-red/15 text-kaefer-red',
	CONGRATULATED: 'bg-kaefer-grass-green/15 text-kaefer-forest-green',
	ATRASADO: 'bg-kaefer-red/15 text-kaefer-red',
	OVERDUE: 'bg-kaefer-red/15 text-kaefer-red',
}

export function StatusPill({ status }: { status: string | null | undefined }) {
	const { t } = useTranslation()

	if (!status) return <span className="text-xs text-muted-foreground">—</span>

	return (
		<span
			className={cn(
				'inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-semibold whitespace-nowrap',
				STATUS_STYLES[status] ??
					'bg-kaefer-light-silver/60 text-kaefer-dark-grey',
			)}
		>
			{t(`kpiMetrics.status.${status}`, { defaultValue: status })}
		</span>
	)
}
